import React from "react";
import { BARA, BOSS, DASHBOARD, GROUILLEUR, MESSAGE, SINISTRE, TRANSACTIONS } from "../assets/icons";
import SvgContainer from "../components/SvgContainer";
import theme from "../theme/theme";
import Bara from "../views/bara/Bara";
import Boss from "../views/boss/Boss";
import Dashboard from "../views/dashboard/Dashboard";
import Grouilleur from "../views/grouilleur/Grouilleur";
import Message from "../views/message/Message";
import Sinistre from "../views/sinistre/Sinistre";
import Transaction from "../views/transaction/Transaction";
import { LocalRouteProps } from "../index.d";
import MesAffaires from "../views/mesAffaires/MesAffaires";


const routes: LocalRouteProps[] = [
  {
    icon: <SvgContainer svg={DASHBOARD} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={DASHBOARD} color={theme.colors.primary} />,
    name: "home",
    path: "/accueil",
    component: <Dashboard />,
  },
  {
    icon: <SvgContainer svg={BOSS} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={BOSS} color={theme.colors.primary} />,
    name: "boss",
    path: "/boss",
    component: <Boss />,
  },
  {
    icon: <SvgContainer svg={GROUILLEUR} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={GROUILLEUR} color={theme.colors.primary} />,
    name: "grouilleurs",
    path: "/grouilleurs",
    component: <Grouilleur />,
  },
  {
    icon: <SvgContainer svg={BARA} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={BARA} color={theme.colors.primary} />,
    name: "bara",
    path: "/bara",
    component: <Bara />,
  },
  {
    icon: <SvgContainer svg={BARA} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={BARA} color={theme.colors.primary} />,
    name: "mes_affaires",
    path: "/mes-affaires",
    component: <MesAffaires />,
  },
  {
    icon: <SvgContainer svg={SINISTRE} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={SINISTRE} color={theme.colors.primary} />,
    name: "sinistres",
    path: "/sinistres",
    component: <Sinistre />,
  },
  {
    icon: <SvgContainer svg={TRANSACTIONS} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={TRANSACTIONS} color={theme.colors.primary} />,
    name: "transactions",
    path: "/transactions",
    component: <Transaction />,
  },
  {
    icon: <SvgContainer svg={MESSAGE} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={MESSAGE} color={theme.colors.primary} />,
    name: "messages",
    path: "/messages",
    component: <Message />,
  },
];

export default routes;
